export const isCubikMail = (mail: string) => {
  //TODO remove theodo
  const validDomains = 'theodo|cubik-partners|opswings';

  const mailRegex = new RegExp(
    '^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+.)?[a-zA-Z]+.)?(' + validDomains + ').(com|fr)$',
  );
  return !!mailRegex.exec(mail);
};
